import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import HomeSupplier from '../components/Supplier/HomeSupplier';
import { RouteComponentProps } from 'react-router';
import { getSupplierInfoAsyncThunk } from '../../Supplier/actions/SupplierActions';



const mapStateToProps = (state: RootState) => ({
    sendSupplierOfferSucced : state.supplierRdc.sendSupplierOfferSucced,
    getSupplierInfoBusy: state.supplierRdc.getSupplierInfoBusy,
    supplierInfo: state.supplierRdc.supplierInfo
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        getSupplierInfo: async () =>{
            await dispatch(getSupplierInfoAsyncThunk())
        }
    })
}

export type HomeSupplierProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps<any>

const HomeSupplierCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(HomeSupplier);

export default HomeSupplierCnn